'use strict';

module.exports = {
    'AX': {type: 'amex', name: 'American Express'},
    'AB': {type: 'amex', name: 'American Express consumer card'},
    'TA': {type: 'amex', name: 'American Express BTA'},

    '3V': {type: 'visa', name: 'Visa 3V'},
    'DL': {type: 'visa', name: 'Visa Delta'},
    'E1': {type: 'visa', name: 'Visa Entropay'},
    'EA': {type: 'visa', name: 'Visa Agos Edreams'},
    'VD': {type: 'visa', name: 'Visa Debit'},
    'VI': {type: 'visa', name: 'Visa Credit'},
    'VV': {type: 'visa', name: 'Visa Vueling'},
    'RV': {type: 'visa', name: 'Visa'},
    'TV': {type: 'visa', name: 'Visa Iberia'},

    'VE': {type: 'electron', name: 'Visa Electron'},

    'CA': {type: 'mastercard', name: 'Mastercard'},
    'EC': {type: 'mastercard', name: 'Mastercard Eurocard'},
    'MD': {type: 'mastercard', name: 'Mastercard Debit'},
    'MC': {type: 'mastercard', name: 'Mastercard'},
    'M6': {type: 'mastercard', name: 'Mastercard'},
    'M4': {type: 'mastercard', name: 'Mastercard'},
    'MP': {type: 'mastercard', name: 'Mastercard'},
    'MI': {type: 'mastercard', name: 'Mastercard'},
    'RM': {type: 'mastercard', name: 'Mastercard'},
    'CM': {type: 'mastercard', name: 'Mastercard'},
    'VB': {type: 'mastercard', name: 'ViaBuy'},
    'TE': {type: 'mastercard', name: 'Eurocard'},
    'TF': {type: 'mastercard', name: 'First Card'},
    'DM': {type: 'mastercard', name: 'Mastercard Debit'},
    'EY': {type: 'mastercard', name: 'Edreams Prepaid'},

    'MA': {type: 'maestro', name: 'Maestro'},

    'CB': {type: 'cartebleuenationale', name: 'Carte Bleue'},

    'DC': {type: 'dinersclub', name: 'Diners Club'},

    'DS': {type: 'discover', name: 'Discover Card'},

    'JC': {type: 'jcb', name: 'Japan Credit Bureau'},

    'ER': {type: 'enroute', name: 'Diners Club enRoute'},

    'TD': {type: 'diners', name: 'Diners TAC'},

    'TP': {type: 'utap', name: 'UATP/Airplus corporate card'},

    'CF': {type: 'unknown', name: 'Cofinoga'},
    'CO': {type: 'unknown', name: 'Cofinoga Opodo'},
    'TC': {type: 'unknown', name: 'Thalys TheCard'},
};
